import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A breaker / fuse panel on a short post: a grey load-centre enclosure with its
// door swung open to show two columns of breaker switches and a main switch,
// plus a conduit feeding up from the ground. The consumer end of the network.
const BOX = "#9aa0a6";
const BOX_DK = "#7c8288";
const INNER = "#3a4046";
const SWITCH = "#cfcfcf";
const MAIN = "#c4392f";
const POST = "#6c727a";

export const fuseBox = defineModel({
  id: "fuse-box",
  batchId: "electric",
  name: "Fuse box",
  tags: ["prop", "electric", "power", "distribution", "breaker", "consumer"],
  summary: "An open breaker panel on a post with switch rows and a main.",
  footprint: 0.25,
  parts(): Part[] {
    const parts: Part[] = [
      // Post and conduit (the conduit hugs the post and runs up into the box).
      { geometry: new THREE.BoxGeometry(0.08, 0.5, 0.08), color: POST, position: [0, 0.25, 0] },
      { geometry: new THREE.CylinderGeometry(0.022, 0.022, 0.62, 8), color: "#5a6066", position: [0.05, 0.31, 0.0] },
      // Enclosure and back panel.
      { geometry: new THREE.BoxGeometry(0.34, 0.44, 0.12), color: BOX, position: [0, 0.66, 0] },
      { geometry: new THREE.BoxGeometry(0.28, 0.38, 0.02), color: INNER, position: [0, 0.66, 0.06] },
      // Open door, hinged on the box's front-left vertical edge so it stays
      // attached (no gap), swung forward-left.
      { geometry: new THREE.BoxGeometry(0.3, 0.42, 0.02), color: BOX_DK, position: [-0.089, 0.66, 0.186], rotation: [0, -1.0, 0] },
      // Main switch and two columns of breakers.
      { geometry: new THREE.BoxGeometry(0.1, 0.05, 0.04), color: MAIN, position: [0, 0.8, 0.08] },
    ];
    for (const x of [-0.06, 0.06]) for (let i = 0; i < 4; i++) {
      parts.push({ geometry: new THREE.BoxGeometry(0.04, 0.04, 0.04), color: SWITCH, position: [x, 0.7 - i * 0.07, 0.08] });
    }
    return parts;
  },
  animations: [],
});
